import { API_BASE_URL } from '../../common/ApiClient';

export enum DataObjectDescriptionVersionUrl {
  edit = '/data-object-description-versions{/id}{?lock,clone}',
  excel = '/data-object-description-versions{/id}/excel',
  upload = '/data-object-description-versions/upload-excel{?id}',
  uploadAlgorithms = '/data-object-description-versions/upload-excel/algorithms{?id,replace}',
  uploadAlternatives = '/data-object-description-versions/upload-excel/alternatives{?id}',
  uploadKeys = '/data-object-description-versions/upload-excel/keys{?id}',
  uploadRules = '/data-object-description-versions/upload-excel/rules{?id}',
  validateDeadlines = '/data-object-description-versions{/id}/execution-deadline-validation',
  generateDeadlines = '/data-object-description-versions{/id}/execution-deadline-preview',
  validateValidationRules = '/data-object-description-versions{/id}/validation-rule-validation',
  byDataObject = '/data-object-description-versions/by-data-object{/id}{?valueDate}',
  relationVersions = '/data-object-description-versions/relation-versions{/id}{?valueDate}',
  cloneAlgorithms = '/data-object-description-versions{/id}/clone-algorithms',
}
export const AlgorithmsExcelUrl =
  API_BASE_URL +
  DataObjectDescriptionVersionUrl.excel +
  '/algorithms{?algorithmIds}';
export const AlternativesExcelUrl =
  API_BASE_URL +
  DataObjectDescriptionVersionUrl.excel +
  '/alternatives{?code,name,alternativeAlgorithms,exceptionsCount}';
export const DataObjectVersionExcelUrl =
  API_BASE_URL + DataObjectDescriptionVersionUrl.excel;
export const KeysExcelUrl =
  API_BASE_URL +
  DataObjectDescriptionVersionUrl.excel +
  '/keys{?code,key,name,statusId*,recipientIds*,ruleTypeId*,voluntary,validPeriod*,description,keyIds*}';
export const ValidationRulesExcelUrl =
  API_BASE_URL +
  DataObjectDescriptionVersionUrl.excel +
  '/rules{?code,condition,description,errorDescription,errorLevelId,expressionLeft,expressionOperatorId,expressionRight,groupCode,ignoreError,ignoreReason,statusId,validPeriod}';
